module.exports = __webpack_public_path__ + "img/formatador_unico_img1.6471303d.jpg";